import { defineStyleConfig } from '@chakra-ui/react';

const Card = defineStyleConfig({
  baseStyle: (props) => ({
    container: {
      bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
      color: props.colorMode === 'dark' ? 'text.primary' : '#1A202C',
      borderRadius: 'lg',
      border: '1px solid',
      borderColor: props.colorMode === 'dark' ? 'gray.600' : '#D1D5DB',
      boxShadow: props.colorMode === 'dark' ? 'dark-sm' : 'md',
    },
    header: {
      padding: '1.75rem 1.75rem 0.75rem',
      borderBottom: '1px solid',
      borderBottomColor: props.colorMode === 'dark' ? 'gray.600' : '#E5E7EB',
    },
    body: {
      padding: '1.75rem',
    },
    footer: {
      padding: '0.75rem 1.75rem 1.75rem',
      borderTop: '1px solid',
      borderTopColor: props.colorMode === 'dark' ? 'gray.600' : '#E5E7EB',
    },
  }),
});

export default Card;
